import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Home from './components/Home.jsx';
import Login from './components/Login.jsx';
import NotarioDashboard from './components/NotarioDashboard.jsx';
import ContadorDashboard from './components/ContadorDashboard.jsx';
import TramiteList from './components/TramiteList.jsx';
import DocumentManagement from './components/DocumentManagement.jsx';
import JustifyDeposits from './components/JustifyDeposits.jsx';
import ApproveDeposits from './components/ApproveDeposits.jsx';
import ConfigureCommission from './components/ConfigureCommission.jsx';
import RejectedComprobantes from './components/RejectedComprobantes.jsx';
import VerifyInvoiceSequence from './components/VerifyInvoiceSequence.jsx';
import FinancialSummary from './components/FinancialSummary.jsx'; // Nueva importación

// Componente para proteger rutas según el rol del usuario
const ProtectedRoute = ({ element, allowedRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-white text-center">Cargando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRole === 'notario' && !user.is_notario) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRole === 'contador' && !user.is_contador) {
    return <Navigate to="/login" replace />;
  }

  return element;
};

// Componente para manejar la ruta raíz
const RootRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="text-white text-center">Cargando...</div>;
  }

  if (user) {
    if (user.is_notario) {
      return <Navigate to="/dashboard/notario" replace />;
    } else if (user.is_contador) {
      return <Navigate to="/dashboard/contador" replace />;
    }
  }

  return <Home />;
};

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<RootRoute />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/dashboard/notario"
            element={<ProtectedRoute element={<NotarioDashboard />} allowedRole="notario" />}
          />
          <Route
            path="/dashboard/contador"
            element={<ProtectedRoute element={<ContadorDashboard />} allowedRole="contador" />}
          />
          <Route path="/tramites" element={<TramiteList />} />
          <Route path="/upload" element={<DocumentManagement />} />
          <Route path="/justify" element={<JustifyDeposits />} />
          <Route path="/approve" element={<ApproveDeposits />} />
          <Route path="/configure-commission" element={<ConfigureCommission />} />
          <Route
            path="/rejected-comprobantes"
            element={<ProtectedRoute element={<RejectedComprobantes />} allowedRole="contador" />}
          />
          <Route
            path="/verify-invoice-sequence"
            element={<ProtectedRoute element={<VerifyInvoiceSequence />} allowedRole="notario" />}
          />
          <Route
            path="/financial-summary"
            element={<ProtectedRoute element={<FinancialSummary />} allowedRole="notario" />}
          />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;